var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkModifyEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.27mm",
    height: "41.27mm",
    viewBox: "0 0 116.99 116.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #005c8e;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.37,22.51L90.86,0l-8.94,8.94L11.61,79.25l3.07,3.07,3.07-3.07,7.7-7.7L81.92,15.08l21.49,21.49L39.24,100.73l-3.07,3.07-24.56-24.56L1.5,116.99l37.74-10.11L106.48,39.64l6.89-6.89c2.83-2.83,2.83-7.41,0-10.23ZM7.64,110.85l6.22-23.21,16.99,16.99-23.21,6.22ZM111.32,28.65l-4.84,4.84-21.49-21.49,5.87-5.87,20.46,20.46c.57.57.57,1.48,0,2.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkModifyEdit);
export default __webpack_public_path__ + "static/media/LK_Modify-Edit.962942db8c04463665770caae193472f.svg";
export { ForwardRef as ReactComponent };